import React, { useState } from 'react';
import BankOrMobileTopUpForm from './BankOrMobileTopUpForm/BankOrMobileTopUpForm';
import BankOrMobileTopUpConfirmation from './BankOrMobileTopUpConfirmation/BankOrMobileTopUpConfirmation';

interface TopUpByBankOrMobileProps {
  paymentMethod: string; 
}

const TopUpByBankOrMobile: React.FC<TopUpByBankOrMobileProps> = ({ paymentMethod }) => {
  const [currentStep, setCurrentStep] = useState<keyof typeof DisplayTopUp>('form');
  const [transferData, setTransferData] = useState(null);

  const DisplayTopUp = {
    form: <BankOrMobileTopUpForm paymentMethod={paymentMethod} setTransferData={setTransferData} setCurrent={setCurrentStep} />,
    confirmation: <BankOrMobileTopUpConfirmation transferData={transferData} setCurrent={setCurrentStep} />,
  };

  return <React.Fragment>{DisplayTopUp[currentStep]}</React.Fragment>;
};

export default TopUpByBankOrMobile;
